import React from "react";
import { useMigration } from "../../liveblocks/migrations";

export default function MigrationLoader({
  children,
}: {
  children: React.ReactNode;
}) {
  // return <>{children}</>;
  const migrated = useMigration();
  return migrated ? <>{children}</> : <></>;
}
